import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'

const data = [
  {
    image:
      'https://ow-prod.oss-cn-beijing.aliyuncs.com/platform_id_1/app_id_null/roled_user_id_null/type_1/a2c97cd8fe7649eda1566732a3dcd2f3.jpg?x-oss-process=image/resize,h_170,m_lfit',
    question: '树枝折断',
    content: '大坝防护林',
    person: '张三',
    mobile: '13456787654',
    status: '已受理',
  },
  {
    image:
      'https://ow-prod.oss-cn-beijing.aliyuncs.com/platform_id_1/app_id_null/roled_user_id_null/type_1/a2c97cd8fe7649eda1566732a3dcd2f3.jpg?x-oss-process=image/resize,h_170,m_lfit',
    question: '树枝',
    content: '大坝防护林',
    person: '张三',
    mobile: '13456787654',
    status: '已受理',
  },
  {
    image:
      'https://ow-prod.oss-cn-beijing.aliyuncs.com/platform_id_1/app_id_null/roled_user_id_null/type_1/a2c97cd8fe7649eda1566732a3dcd2f3.jpg?x-oss-process=image/resize,h_170,m_lfit',
    question: '折断',
    content: '大坝防护林',
    person: '张三',
    mobile: '13456787654',
    status: '已受理',
  },
  {
    image:
      'https://ow-prod.oss-cn-beijing.aliyuncs.com/platform_id_1/app_id_null/roled_user_id_null/type_1/a2c97cd8fe7649eda1566732a3dcd2f3.jpg?x-oss-process=image/resize,h_170,m_lfit',
    question: '折断',
    content: '大坝防护林',
    person: '张三',
    mobile: '13456787654',
    status: '已受理',
  },
]

const ArticleItem = styled.div`
  background-image: linear-gradient(
    90deg,
    #003766 0%,
    rgba(0, 52, 96, 0.3) 100%
  );
  border-radius: 4px;
  ${tw`flex items-center gap-5 p-2 relative`}
  .blocktitle {
    color: #e6f9f2;
  }
  .blocktext {
    color: #ffffb0;
  }
  .status {
    width: 66px;
    height: 24px;
    background-image: linear-gradient(
      270deg,
      rgba(15, 172, 209, 0.45) 0%,
      rgba(26, 204, 183, 0.45) 100%
    );
    border: 1px solid #2ebad2;
    border-radius: 0 8px 0 8px;
    ${tw`absolute right-0 top-0 text-center text-xs pt-1`}
  }
`

const Article = function () {
  return (
    <div className="h-full w-full">
      <div className="flex flex-col gap-3 justify-between">
        {data.map((d) => {
          return (
            <ArticleItem>
              <div>
                <img
                  src={d.image}
                  alt="img"
                  style={{ width: '120px', height: '90px' }}
                />
              </div>
              <div className="flex flex-col gap-2">
                <div className="text-sm font-bold blocktitle">{d.question}</div>
                <div className="text-xs blocktext">{d.content}</div>
                <div className="text-xs blocktext">
                  {d.person} {d.mobile}
                </div>
              </div>
              <div className="status">{d.status}</div>
            </ArticleItem>
          )
        })}
      </div>
    </div>
  )
}

export default Article
